var React = require('react');

function Nobleach (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop---Phase-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Ikoner/Do-not-bleach","transform":"translate(.333 .23)","stroke":"#000"},[React.createElement("g",{"id":"Ej_blekning","transform":"translate(-.121 3.075)","key":0},React.createElement("path",{"d":"M20.121 1.927L1.926 31.04h36.391L20.121 1.927z","id":"Rectangle-24","strokeWidth":"2"})),React.createElement("g",{"id":"x","transform":"translate(1 .575)","strokeLinecap":"square","strokeWidth":"2","key":1},[React.createElement("path",{"d":"M36.924 1.005L.96 37.624","id":"Line-29","key":0}),React.createElement("path",{"d":"M.96 1.005l35.964 36.619","id":"Line-29-Copy","key":1})])])));
}

Nobleach.defaultProps = {"width":"41","height":"40","viewBox":"0 0 41 40"};

module.exports = Nobleach;

Nobleach.default = Nobleach;
